// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB1MEQKTEoOkR23r8lRl78xb7E5ohE-kpk",
  authDomain: "dactrha-77ae0.firebaseapp.com",
  projectId: "dactrha-77ae0",
  storageBucket: "dactrha-77ae0.firebasestorage.app",
  messagingSenderId: "632398659125",
  appId: "1:632398659125:web:c91a0c637241a2cb7efb7c",
  measurementId: "G-TB6Q2PW5EM"
};

// Initialize Firebase
let app;
let messaging = null;
let analytics = null;

try {
  app = initializeApp(firebaseConfig);
  
  // Initialize Analytics (only in browser)
  if (typeof window !== 'undefined') {
    analytics = getAnalytics(app);
  }
} catch (error) {
  console.error('Firebase initialization error:', error);
}

// Initialize Firebase Cloud Messaging
export const initializeMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported && app) {
      messaging = getMessaging(app);
      return messaging;
    }
    console.warn('FCM is not supported in this browser');
    return null;
  } catch (error) {
    console.error('Error initializing FCM:', error);
    return null;
  }
};

// Request notification permission and get FCM token
export const requestNotificationPermission = async () => {
  try {
    if (!messaging) {
      messaging = await initializeMessaging();
    }
    
    if (!messaging) {
      throw new Error('FCM not supported');
    }

    if (typeof Notification === 'undefined') {
      throw new Error('Notifications not supported');
    }

    let permission = Notification.permission;
    if (permission !== 'granted') {
      permission = await Notification.requestPermission();
    }
    
    if (permission === 'granted') {
      // Get FCM token with VAPID key
      const token = await getToken(messaging, {
        vapidKey: 'BABakVB_EBg0JEp3I84M855iW_EduWXXOtpAR8kgeCJRMi1D-N1sUMsR-Tay19-7qAi_kktzGf1Wrrs36cag618'
      });
      
      console.log('FCM Token:', token);
      return { permission: 'granted', token };
    }

    if (permission === 'denied') {
      console.log('Notification permission denied');
      return { permission: 'denied', token: null };
    }

    return { permission: 'default', token: null };
  } catch (error) {
    console.error('Error getting notification permission:', error);
    return { permission: 'error', token: null, error };
  }
};

// Get FCM token only if permission is already granted
export const getFcmToken = async () => {
  try {
    if (!messaging) {
      messaging = await initializeMessaging();
    }

    if (!messaging) {
      throw new Error('FCM not supported');
    }

    if (typeof Notification === 'undefined') {
      throw new Error('Notifications not supported');
    }

    if (Notification.permission !== 'granted') {
      return { permission: Notification.permission, token: null };
    }

    const token = await getToken(messaging, {
      vapidKey: 'BABakVB_EBg0JEp3I84M855iW_EduWXXOtpAR8kgeCJRMi1D-N1sUMsR-Tay19-7qAi_kktzGf1Wrrs36cag618'
    });

    return { permission: 'granted', token };
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return { permission: 'error', token: null, error };
  }
};

// Listen for foreground messages
export const onForegroundMessage = (callback) => {
  if (!messaging) {
    console.warn('Messaging not initialized');
    return () => {};
  }
  
  return onMessage(messaging, (payload) => {
    console.log('Foreground message received:', payload);
    callback(payload);
  });
};

export { app, messaging, analytics };
export default app;
